module.exports = __webpack_public_path__ + "img/default_network.57b06603.png";